<template>
  <div class="container">
    <img
      id="moveImg"
      class="img"
      src="@/assets/images/avator-img.png"
      :style="giftStyle"
      alt
      @touchstart="down()"
      @touchmove="move()"
      @touchend="end()"
      @load="e=>loadImg(e)"
    >
  </div>
</template>

<script>
export default {
  name: 'Test',
  data() {
    return {
      giftStyle: {},
      rate: 0.34739583333333335,
      flags: false,
      position: {
        x: 0, // 手指按下去是的点的x坐标
        y: 0 // 手指按下去时的点的y坐标
      },
      nx: '', // 拖拽的x坐标距离
      ny: '', // 拖拽的y坐标距离
      dx: '', // moveImg距离左边界的offsetLeft
      dy: '', // moveImg距离上边界的offsetTop
      xPum: '', // 手指拖拽物体移动的新x坐标
      yPum: '', // 手指拖拽物体移动的新y坐标
      screenW: 0,
      screenH: 0,
      divW: 0,
      divH: 0
    }
  },
  methods: {
    loadImg(el) {
      const winW = document.documentElement.clientWidth
      const winH = document.documentElement.clientHeight
      this.screenW = winW
      this.screenH = winH
      this.divW = el.target.height * this.rate
      this.divH = el.target.width * this.rate
      this.giftStyle = {
        'z-index': 300,
        position: 'absolute',
        left: `${winW / 2 - (el.target.width * this.rate) / 2}px`,
        top: `${winH / 2 - (el.target.height * this.rate) / 2}px`,
        height: `${el.target.height * this.rate}px`,
        width: `${el.target.width * this.rate}px`
      }
    },
    down() {
      this.flags = true
      var touch
      if (event.touches) {
        touch = event.touches[0]
      } else {
        touch = event
      }
      this.position.x = touch.clientX
      this.position.y = touch.clientY
      // console.log(this.position.x , this.position.y, 'this.position.x, this.position.y')
      const moveImg = document.getElementById('moveImg')
      this.dx = moveImg.offsetLeft
      this.dy = moveImg.offsetTop
      // console.log(moveImg, 'moveImg')
      // console.log(this.dx , this.dy, 'this.dx, this.dy')
    },
    move() {
      if (this.flags) {
        var touch
        if (event.touches) {
          touch = event.touches[0]
        } else {
          touch = event
        }
        this.nx = touch.clientX - this.position.x
        this.ny = touch.clientY - this.position.y
        // console.log(this.nx , this.ny, 'this.nx, this.ny')
        this.xPum = this.dx + this.nx
        this.yPum = this.dy + this.ny
        if (this.xPum < 0) {
          this.xPum = 0
        }
        if (this.xPum > this.screenW - this.divW) {
          this.xPum = this.screenW - this.divW
        }
        if (this.yPum < 0) {
          this.yPum = 0
        }
        if (this.yPum > this.screenH - this.divH) {
          this.yPum = this.screenH - this.divH
        }
        // console.log(this.xPum , this.yPum, 'this.xPum, this.yPum')
        const moveImg = document.getElementById('moveImg')
        moveImg.style.left = this.xPum + 'px'
        moveImg.style.top = this.yPum + 'px'
        // 阻止页面的滑动默认事件
        document.addEventListener(
          'touchmove',
          function() {
            // 1.2 如果碰到滑动问题，请注意是否获取到 touchmove
            event.stopPropagation() // 阻止冒泡事件
          },
          false
        )
      }
    },
    // 鼠标释放时候的函数
    end() {
      this.flags = false
      console.log(this.xPum / this.rate, this.yPum / this.rate, 'realLeft and realTop')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
    position: relative;
    width: 100%;
    height: 100%;
    .img {
        animation: imgSlide 7s linear;
        // animation: name duration timing-function delay iteration-count direction fill-mode;
    }
    .nut-drag {
        position: absolute;
        left: 0px;
        right: 0px;
        top: 0px;
        bottom: 0px;
    }
}
@keyframes imgslide {
    0% {
        transform: scale(1.5);
    }
    25% {
        transform: scale(1);
    }
    50% {
        top: 100px;
    }
    75% {
        top: 60px;
    }
    100% {
        top: 20px;
    }
}
</style>
